// src/components/admin/AdminPanel.jsx
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Container,
  Typography,
  Paper,
  Tabs,
  Tab,
  Alert,
  Button,
  Chip,
} from "@mui/material";
import { Feedback, Storage, Settings, ExitToApp } from "@mui/icons-material";
import FeedbackDashboard from "./FeedbackDashboard";
import DatabaseDashboard from "./database/DatabaseDashboard";
import AdminHeader from "./layout/AdminHeader";
import { logout, selectUser } from "../../store/slices/authSlice";
import { useNavigate } from "react-router-dom";

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [dbAction, setDbAction] = useState(null);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/admin/login");
  };

  const requestDbAction = (action) => {
    setDbAction(action);
    setActiveTab(1);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <FeedbackDashboard requestDbAction={requestDbAction} />;
      case 1:
        return <DatabaseDashboard dbAction={dbAction} setDbAction={setDbAction} />;
      case 2:
        return (
          <Box sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
              Настройки (В разработка)
            </Typography>
            <Alert severity="info">Тази секция е в процес на разработка.</Alert>
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f5f5f5" }}>
      <AdminHeader />

      <Container maxWidth="2xl" sx={{ py: 4 }}>
        <Paper elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{
              bgcolor: "#1976d2",
              "& .MuiTab-root": {
                color: "white",
                opacity: 0.7,
                "&.Mui-selected": {
                  color: "white",
                  opacity: 1,
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "white",
                height: 3,
              },
            }}
          >
            <Tab
              icon={<Feedback />}
              iconPosition="start"
              label="Обратна връзка"
            />
            <Tab icon={<Storage />} iconPosition="start" label="База данни" />
            <Tab icon={<Settings />} iconPosition="start" label="Настройки" />
          </Tabs>

          <Box sx={{ p: 3 }}>{renderTabContent()}</Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default AdminPanel;
